import { DatePipe, formatDate } from '@angular/common';
import {Component,ElementRef,Input,OnInit,ViewChild,Output,EventEmitter,ViewChildren} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AlertController,IonInfiniteScroll,LoadingController,IonContent,ModalController,PopoverController,ToastController, Platform, IonSlides} from '@ionic/angular';
import { ServicesProvider } from 'src/providers/services';
import { FileUploadService } from 'src/providers/upload';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { InViewportMetadata } from 'ng-in-viewport';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { CallNumber } from '@ionic-native/call-number/ngx';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import {  HttpParams } from '@angular/common/http';

import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { AddmemPage } from '../addmem/addmem.page';
import { AddCall } from 'src/providers/addvCall';
import { ReviewPage } from '../review/review.page';
import { Payment } from 'src/providers/payment';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { CommonService } from 'src/providers/common';
import { MediaElementPlayer } from 'mediaelement';
import { RatingSortpagePage } from '../rating-sortpage/rating-sortpage.page';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

declare var google;

@Component({
  selector: 'app-lab',
  templateUrl: './lab.page.html',
  styleUrls: ['./lab.page.scss'],
})
export class LabPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild('mapElement', { static: false }) mapElement: ElementRef;
  @Output() ChangeEvent = new EventEmitter<string>();
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren('newVdo') vdoPlayer: MediaElementPlayer;

  currentPlaying = null;
  @Input() showTypeofBooking;
  map: any;
  docpro: any = '';
  @ViewChild(IonSlides) slides: IonSlides;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  vdo: any;
  idx: any;
  refreshEvent: any;
  pagechk: any;
  searchValue1: any = '';
  rate: any;
  presentView: string;
  bookingPage: boolean;
  labProfile: boolean;
  bookingConformPage: boolean;
  canceldBookingIcon: boolean;
  viewBookingInfo: boolean;
  viewBookingList: boolean;
  viewCanceledBookingList: boolean;
  viewCancelBookingInfo: boolean;
  backValue: string;
  headerValue: string;
  showRefundPopUp: boolean;
  reShdulBtnValue: string;
  playVid: any;
  ProfileVideo: any;
  storeFlowValue: any;
  oldVideoTarget: any;
  test: any = 'id';
  searhFilter: any = '';
  test1: any = 'id1';
  familyMemId: any;
  getLabList: any = [];
  getLabListss: any = [];
  dealslistRef: any = [];
  particularLab: any;
  storeLabId: any;
  labTestPakage: any;
  testId: any;
  labSubTestList: Array<{
    testId: any;
    testName: any;
    dealsDetails: any;
    cost: any;
    instuction: any;
    selected: boolean;
    nonselect: boolean;
    catid: any;
  }> = [];
  storeSelectedLapTest: Array<{
    testId: any;
    testName: any;
    test_amount: any;
  }> = [];
  storeSelectedLapTestConverted: Array<{
    lab_test_id: any;
    test_amount: any;
    deal_id: any;
    deal_option: any;
    deal_amount: any;
    actualamt: any;
  }> = [];
  TotalCost: number;
  actualCost: number = 0;
  discAmt: number = 0;
  patientDetails: any;
  chsApmntDate: any;
  chsApmntTime: any;
  bookingListData: any = [];
  EmtyDataList: any = null;
  EmtyData: any = null;
  particularBkgData: any;
  bookingHistoryList: any = [];
  particularHisData: any;
  storeBookingId: any;
  currentTime: any;
  currentDate: any;
  storeHisListIndex: any;
  particularReschData: any;
  storeLabName: any;
  isConfirmed : boolean
  search: any;
  terms_and_condition_file: any;
  offerSoring: boolean;
  storePatientName: any;
  getDate: any;
  getTime: any;
  StoreWayBookingPageFlow: any;
  pageNo: number = 1;
  noData: any = 0;
  skeletonLoad: any = [];
  noMedia: string;
  showVideoOptins: boolean;
  selectedDate: any;
  Date: any;
  reletionList: any;
  refPage: any;
  bookingAmnt: any;
  nextCount = [];
  nextbookinglistcount: any;
  setTime: any;
  storeWorkingHours: any = [];
  days: any = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  checkCrnTime: string;
  EmptyLabStest: boolean;
  currentMemberId: string;
  LabRqst: any;
  offrSortOrder: any;
  rateSortOrder: any;
  isShowHeaderValue: boolean = true;
  viewReferralIndex: any;
  rateSoring: boolean = true;
  instList: any = [];
  dynClass: any;
  reviewCmt: any = [];
  showProgressBar: boolean = false;
  addImg: any;
  lattitude: any;
  longititude: any;
  tymVal: any;
  isShow: any;
  commentlength: any;
  paymentid: any;
  isDateSel: boolean;
  counts: number = 0;
  dblClikedIndex: any;
  likedPopUpStatus: boolean;
  storedPath: null;
  minTime: any;
  maxTime: any;
  hourValues = [];
  scrollEvent: any;
  cardNum = 5;
  hitApi = [];
  reftest: any = [];
  LabAddress: any;
  p_Name: any;
  referenceid: any;
  order_Id: any;
  paymentGatewayName: any;
  commonheadervalue: any = 'Lab';
  @Input() typeid;
  commonheadervalueData: any;
  storeMemberPatientId: any;
  storeMemberPatient: any;
  userIP: any;
  payType: any;
  gopayment: boolean = false;
  isMuteVideo: boolean = false;
  currentVidEvent: any;
  currentVidIndex: any;
  currentVidSindex: any;
  Addcheckvarible: boolean = true;
  presentInfoViewBack :any;
  revArr: any;
  pagenorev: any;
  reviewCommand: any = [];
  LocationIcon: any;
  defaultImage = 'assets/img/Vector.png';
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';

  constructor(
    private router: Router,
    public alertCtrl: AlertController,
    private services: ServicesProvider,
    public loadingController: LoadingController,
    public toastController: ToastController,
    public modalCtrl: ModalController,
    private datePipe: DatePipe,
    public fileupload: FileUploadService,
    private geolocation: Geolocation,
    public PopupalertPage: PopupalertPage,
    public callNo: CallNumber,
    public popoverCtrl: PopoverController,
    public addCall: AddCall,
    private payment: Payment,
    public activeRoute: ActivatedRoute,
    private httpClient: HttpClient,
    private platform: Platform,
    public common: CommonService,
    private file: File,
    private fileOpener: FileOpener,
  ) { }
  public commonAnd = CommonService;

  ngOnChanges() {
    debugger;
    this.commonheadervalue = 'commonbooking';
    if (this.commonheadervalueData == true) {
      this.commonheadervalue = 'Lab';
    }

    if (this.showTypeofBooking == 'booking') {
      this.wayOfBookingListpages('bookingList');
    } else if (this.showTypeofBooking == 'booking hitory') {
      this.wayOfBookingListpages('bookingHisList');
    } else if (this.showTypeofBooking == 'Referral') {
      this.presentView = 'viewReferral';
      this.openreferral();
    } else if (this.typeid == 0) {
      this.wayOfBookingListpages('bookingList');
    }
  }

  ngOnInit() {
    for (let i = 1; i <= 5; i++) {
      this.skeletonLoad.push(i);
    }
    this.noMedia = 'assets/img/Vector.png';
    this.currentDate = new Date().toISOString().split('T')[0];
    this.currentTime = new Date().toLocaleTimeString();
    this.currentTime = this.currentTime.slice(0, 5);
  }

  onImageErrors(event: Event,value:any): void {
    if(value == 'Male'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    }else if(value == 'Female'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
    else if(value == 'Vector'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.defaultImage;
    }
  }


  scrollByPoint() {
    this.content.scrollByPoint(100, 100, 300);
  }

  //-----DialPad---------------------
  openDialpad(phoNo) {
    try {
      this.callNo.callNumber(phoNo, true);
    } catch (e) {
      alert(e);
    }
  }
  //-----DialPad---------------------


  //------------\/------PRE DEFINE FUNCTION-----\/------------//

  doRefresh(event, page) {
    this.refreshEvent = event;
    this.pageNo = 1;
    this.EmtyData = null;

    if (page == 'listLab') {
      this.EmtyDataList = null;
      this.getLabList = [];
      this.showLabListPage(1);
    } else if (page == 'listBookingOrHis') {
      this.wayOfBookingListpages(this.StoreWayBookingPageFlow);
    }
  }
  refFunc() {
    if (this.refreshEvent) {
      this.refreshEvent.target.complete();
    }
  }
  infyFunc() {
    if (this.scrollEvent) {
      this.scrollEvent.target.complete();
    }
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'please Wait',
    });
    await loading.present();
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async Alertpopup(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();

    alert.onDidDismiss().then((data) => {
      if (data.data == 'Success') {
        this.router.navigate(['payment']);
      }
    });
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
  }

  loadData(event) {
    if (this.noData != 0) {
      this.scrollEvent = event;
      this.pageNo += 1;
      this.showLabListPage(2);
    }
  }
  loadData1(event, page) {
    this.scrollEvent = event;
    this.pageNo += 1;
    if (this.StoreWayBookingPageFlow == 'bookingList') {
      this.bookingList();
    } else if (this.StoreWayBookingPageFlow == 'bookingHisList') {
      this.bookingHis();
    }
  }

  //----------/\-------PRE DEFINE FUNCTION-------/\---------//

  //-----------------------><--------------------------><-------------------------------><---------------------------//

  // -----\/-----SOME SPECIAL FUNCTION------\/-------//

  checkVideo(id, index, Sindex, frm) {
    let video = document.getElementById(id);
    let d = this;
    video.onended = function () {
      frm == 1
        ? (d.getLabList[index].LabmediaDetails[Sindex].playMode = false)
        : (d.particularLab.LabmediaDetails[Sindex].playMode = false);
    };
  }

  onIntersection1($event: any, id: any, index: any, Sindex) {
    let _obj = this;
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    if ($event.visible == false) {
      $event.target.autoplay = false;
    }

    let playPromise;
    if (ratio == 1) {
      playPromise = vid.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            vid.play();
            _obj.getLabList[index].LabmediaDetails[Sindex].playMode = true;
          })
          .catch((error) => {
            vid.pause();
            _obj.getLabList[index].LabmediaDetails[Sindex].playMode = false;
          });
      }
    } else if (ratio > 0.0 && ratio <= 0.3) {
      playPromise = vid.play();
      if (playPromise !== undefined) {
        playPromise
          .then((_) => {
            vid.play();
            _obj.getLabList[index].LabmediaDetails[Sindex].playMode = true;
          })
          .catch((error) => {
            vid.pause();
            _obj.getLabList[index].LabmediaDetails[Sindex].playMode = false;
          });
      }
    } else {
      if ((this.getLabList[index].LabmediaDetails[Sindex].playMode = true)) {
        vid.pause();
        this.getLabList[index].LabmediaDetails[Sindex].playMode = false;
      }
    }
  }

  onIntersection($event, id, index, Sindex) {
    this.currentVidEvent = $event;
    this.currentVidIndex = index;
    this.currentVidSindex = Sindex;
    let _obj = this;
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;

    const vid = target;
    if ($event.visible == false) {
      $event.target.autoplay = false;
    }
    let playPromise;
    if (ratio >= 0.8) {
      if (this.oldVideoTarget && this.oldVideoTarget != vid) {
        this.oldVideoTarget.pause();
      }
      if (this.isMuteVideo) {
        playPromise = vid.play();
        this.oldVideoTarget = vid;
        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              vid.play();
              _obj.getLabList[index].LabmediaDetails[Sindex].playMode = true;
            })
            .catch((error) => {
              vid.pause();
              if (_obj.getLabList)
                _obj.getLabList[index].LabmediaDetails[Sindex].playMode = false;
            });
        }
      }
    } else {
      if ((_obj.getLabList[index].LabmediaDetails[Sindex].playMode = true)) {
        vid.pause();
        _obj.getLabList[index].LabmediaDetails[Sindex].playMode = false;
      }
    }
  }

  playVideo($event: any, id: any, index: any, Sindex, value: any) {
    this.showPlyOptn();

    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        this.playVid.play();
        this.getLabList[index].LabmediaDetails[Sindex].playMode = true;
        break;
      }
      case 'pause': {
        this.playVid.pause();
        this.getLabList[index].LabmediaDetails[Sindex].playMode = false;
        break;
      }
    }
  }

  playProVideo(Sindex, mid, value) {
    debugger;
    this.ProfileVideo = document.getElementById(mid);
    switch (value) {
      case 'play': {
        this.ProfileVideo.play();
        this.particularLab.LabmediaDetails[Sindex].playMode = true;
        break;
      }
      case 'pause': {
        this.ProfileVideo.pause();
        this.particularLab.LabmediaDetails[Sindex].playMode = false;
        break;
      }
    }
  }

  showPlyOptn() {
    this.showVideoOptins = true;
    setTimeout(() => {
      this.showVideoOptins = null;
    }, 5000);
  }

  selectTest(i) {
    this.labSubTestList[i].selected = !this.labSubTestList[i].selected;
    if (this.labSubTestList[i].selected == true) {
      this.actualCost = this.actualCost + Number(this.labSubTestList[i].cost);
      if (this.labSubTestList[i].dealsDetails.length > 0) {
        if (this.labSubTestList[i].dealsDetails[0].deal_options == 'Amount') {
          this.discAmt =
            this.discAmt +
            Number(this.labSubTestList[i].dealsDetails[0].deal_amount);
        } else if (
          this.labSubTestList[i].dealsDetails[0].deal_options == 'Percentage'
        ) {
          this.discAmt =
            this.discAmt +
            (Number(this.labSubTestList[i].cost) *
              Number(this.labSubTestList[i].dealsDetails[0].deal_amount)) /
            100;
        }
      }
      this.instList.push(this.labSubTestList[i]);
    } else {
      this.actualCost = this.actualCost - Number(this.labSubTestList[i].cost);
      if (this.labSubTestList[i].dealsDetails.length > 0) {
        if (this.labSubTestList[i].dealsDetails[0].deal_options == 'Amount') {
          this.discAmt =
            this.discAmt -
            Number(this.labSubTestList[i].dealsDetails[0].deal_amount);
        } else if (
          this.labSubTestList[i].dealsDetails[0].deal_options == 'Percentage'
        ) {
          this.discAmt =
            this.discAmt -
            (Number(this.labSubTestList[i].cost) *
              Number(this.labSubTestList[i].dealsDetails[0].deal_amount)) /
            100;
        }
      }

      let idx = 0;
      for (let item of this.instList) {
        if (this.labSubTestList[i].testId == item.testId) {
          this.instList.splice(idx, 1);
        }
        idx++;
      }
    }
    this.TotalCost = this.actualCost - this.discAmt;
    this.TotalCost = Number(this.TotalCost.toFixed(3));
  }

  backtobooklist: boolean = false;

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: 'normal',
        curdate: new Date().toString().split(' ')[0] + ', ' + new Date().toString().split(' ')[1] + ' ' + new Date().toString().split(' ')[2],
      },
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss().then((data) => {
      debugger;
      if (data.data) {
        this.refPage = false;
        this.Date = data.data;
        this.getDate = this.getFormattedDateTime(this.Date, 'Date1');
        var getDayId = this.Date.getDay();

        let actualamt = 0;
        this.TotalCost = 0;
        this.getlabpackage_test();

        for (let item of this.testslt) {
          const fromDate = new Date(this.Date);

          if (item.dealsDetails.length > 0) {
            const dealValidFrom = new Date(
              item.dealsDetails[0].deal_valid_from
            );
            const dealValidTo = new Date(item.dealsDetails[0].deal_valid_to);

            const fromDateWithoutTime = new Date(
              fromDate.getFullYear(),
              fromDate.getMonth(),
              fromDate.getDate()
            );
            const dealValidFromWithoutTime = new Date(
              dealValidFrom.getFullYear(),
              dealValidFrom.getMonth(),
              dealValidFrom.getDate()
            );
            const dealValidToWithoutTime = new Date(
              dealValidTo.getFullYear(),
              dealValidTo.getMonth(),
              dealValidTo.getDate()
            );

            if (
              dealValidFromWithoutTime <= fromDateWithoutTime &&
              fromDateWithoutTime <= dealValidToWithoutTime
            ) {
              if (item.dealsDetails[0].deal_options === 'Amount') {
                actualamt =
                  Number(item.cost) - Number(item.dealsDetails[0].deal_amount);
              } else if (item.dealsDetails[0].deal_options === 'Percentage') {
                actualamt =
                  Number(item.cost) -
                  (Number(item.cost) *
                    Number(item.dealsDetails[0].deal_amount)) /
                  100;
              }
            } else {
              actualamt = Number(item.cost);
            }

            this.TotalCost += actualamt;
            this.TotalCost = Number(this.TotalCost.toFixed(3));
          } else {
            this.TotalCost += Number(item.cost.toFixed(3));
          }
        }
        this.chsApmntDate =  this.Date.getFullYear() + '-' + ('0' + (this.Date.getMonth() + 1)).slice(-2) +  '-' + ('0' + this.Date.getDate()).slice(-2);
        this.isDateSel = true;
        this.EmptyLabStest = true;
        this.testId = null;
        this.labSubTestList = [];
        this.instList = [];
        this.chsApmntTime = null;
        this.getTime = '';

        if (this.reShdulBtnValue == 'Reschedule') {
          this.backtobooklist = true;
        }
      }
      this.dateValidation(getDayId);
    });
  }

  showslt_test: any = [];

  testList() {
    let data = null;
    this.showslt_test = [];

    for (let item of this.testslt) {
      this.showslt_test.push(item.testName);
      if (data) {
        data += ',' + item.testName;
      } else {
        data = item.testName;
      }
    }
    console.log('kon', this.showslt_test);
    console.log('kong', this.showslt_test[0].length);

    return data;
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'am' : 'pm';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        return timeString;
      case 'Date':
        if (
          this.addCall.selectedLanguage == 'en' ||
          this.addCall.selectedLanguage == 'ea'
        ) {
          return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy');
        } else {
          let dateCall = new Date(dateTime);
          let months = ['يناير','فبراير','مارس','إبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'];
          let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' +  dateCall.getFullYear();
          return arDate;
        }
      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy h:mm a');
      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return formatDate(new Date(dateTime), 'dd-MMM-yy', 'en-us');
        } else {
          let dateCall = new Date(dateTime);
          let months = ['يناير','فبراير','مارس','إبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر', 'ديسمبر'];
          let arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  cheakTime(testTime) {
    this.checkCrnTime = new Date().toLocaleTimeString().split(' ')[0];
    if (testTime < this.checkCrnTime) {
      return true;
    } else {
      return false;
    }
  }
  // --------/\-----Some Special Function's-------/\------//
  isAndroid: any = null;
  isIos: any = null;

 async ionViewWillEnter() {
    // debugger;
    // this.LocationIcon = true;
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    let options = {
      enableHighAccuracy: true,
      timeout: 5000
    };



    // this.geolocation.getCurrentPosition(options).then((resp) => {
    //   this.LocationIcon = true;
    //   this.lattitude = resp.coords.latitude;
    //   this.longititude = resp.coords.longitude;
    //   console.log(this.lattitude, "==========");
    //   console.log(this.longititude, "=====");
    // }, err => {
    //   this.LocationIcon = false;
    //   this.lattitude = 29.62107798734671;
    //   this.longititude = 47.587719496877924;
    //   console.log('Error getting location', err);
    // });

    try {
      let options = {
        enableHighAccuracy: true,
        timeout: 5000
      };
     await this.geolocation.getCurrentPosition(options).then((resp) => {
        this.LocationIcon = true;
        this.lattitude = resp.coords.latitude;
        this.longititude = resp.coords.longitude;
        console.log(this.lattitude, "==========");
        console.log(this.longititude, "=====");
        // this.getDocDetails(1);
      }, err => {
        this.LocationIcon = false;
        this.lattitude = 29.62107798734671;
        this.longititude = 47.587719496877924;
        // this.getDocDetails(1);
        console.log('Error getting location', err);
      });
    } catch (e) {
      console.log(e);
    }


    this.common.videoSound = true;
    this.getAdd();
    this.docpro = '';
    this.commonheadervalue = 'Lab';
    this.revArr = [];
    this.isShowHeaderValue = true;
    this.presentView = 'labListPage';
    this.showoffertest = true;
    this.bookingPage = false;
    this.showcoment = false;
    this.commonheadervalueData = false;
    setTimeout(() => {
      this.searhFilter = 'Search';
      this.search = false;
      this.searchValue1 = '';
    }, 200);
    console.log(this.activeRoute.snapshot.paramMap.get('frmPage'));
    this.pageNo = 1;
    this.showProgressBar = true;
    this.TotalCost = 0;
    this.actualCost = 0;
    this.discAmt = 0;
    this.instList = [];
    this.pageNo = 1;
    this.search = false;
    this.searhFilter = '';
    this.EmtyData = null;
    this.EmtyDataList = null;
    this.getLabList = [];
    this.oldbookingid = 0;
    let frmAd = this.activeRoute.snapshot.paramMap.get('frmAd');
    this.resetVariable();

    switch (localStorage.getItem('NopayGoBack')) {
      case 'newEnter': {
        this.getIntLocation();
        localStorage.setItem('NopayGoBack', null);
        break;
      }
      case 'BookingConPage': {
        this.AddBooking(this.storeFlowValue);
        localStorage.setItem('NopayGoBack', null);
        break;
      }
      default: {
        this.getIntLocation();
        break;
      }
    }
  }

  getIntLocation() {
      let frmAd = this.activeRoute.snapshot.paramMap.get('frmAd');
      let docpage = this.activeRoute.snapshot.paramMap.get('frmPage');
      if (this.platform.is('ios')) {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000,
        };
        this.geolocation.getCurrentPosition(options).then(
          (resp) => {
            // this.lattitude = resp.coords.latitude;
            // this.longititude = resp.coords.longitude;
            if (docpage == 'labreferral') {
              this.openreferral();
            } else if (frmAd == '1') {
              let labId = this.activeRoute.snapshot.paramMap.get('vendorId');
              this.selectLab(labId, 'labprofile', '');
            } else {
              this.showLabListPage(3);
            }
          },
          (err) => {
            // this.lattitude = 10.5968315;
            // this.longititude = 77.3077059;
            console.log(err,"map_error");

            if (docpage == 'labreferral') {
              this.openreferral();
            } else {
              this.showLabListPage(4);
            }
          }
        );
      } else if (this.platform.is('android')) {
        // this.lattitude =  this.commonAnd.androidLatitude ?? 29.62107798734671;
        // this.longititude =  this.commonAnd.androidLongitude ?? 47.587719496877924;
        if (docpage == 'labreferral') {
          this.openreferral();
        } else if (frmAd == '1') {
          let labId = this.activeRoute.snapshot.paramMap.get('vendorId');
          this.selectLab(labId, 'labprofile', '');
        } else {
          this.showLabListPage(3);
        }
      }
    }





  scroll() {
    this.content.scrollToBottom(1000);
  }
  scrolltop() {
    this.content.scrollToTop(1000);
  }

  showLabListPage(from) {
    try {
      if (this.pageNo == 1) {
        this.scroll();
        this.getLabList = [];
      }
      if (from == 2) {
        var count = 15;
      } else {
        this.nextCount = [];
        this.hitApi = [];
        count = 15;
        this.cardNum = 5;
      }
      if (this.LabRqst) {
        this.LabRqst.unsubscribe();
      }
      let getDate = new Date();
      this.currentDate =  getDate.getFullYear() + '-' + (getDate.getMonth() + 1) +  '-' +  getDate.getDate();
      this.presentView = 'labListPage';
      this.canceldBookingIcon = false;
      this.backValue = 'goHome';
      this.getDate = null;
      this.getTime = null;
      this.chsApmntDate = null;
      this.chsApmntTime = null;
      if (this.pageNo == 1) {
        this.EmtyDataList = null;
      }
      let apiData = JSON.stringify({
        Searchcontent: this.search,
        currentDate: this.currentDate,
        Lab: this.searhFilter,
        offerBasedSorting: this.offerSoring,
        offerBasedSortingOrder: this.offrSortOrder,
        ratingBasedSorting: this.rateSoring,
        ratingBasedSortingOrder: this.rateSortOrder,
        limit: 4,
        pageno: this.pageNo,
        lat: this.lattitude,
        longitude: this.longititude,
        patientId: localStorage.getItem('patient_id'),
      });
      this.LabRqst = this.services.postRequest('getlabList', apiData).subscribe(
        (res) => {
          this.EmtyDataList = res.status;
          this.showProgressBar = false;
          if (this.common.videoSound) {
            const interval = setInterval(() => {
              console.log('Trigger from API');
              console.log('No Video');
              this.currentPlaying = null;
              if (this.vdoPlayer) {
                console.log('Video');
                this.didScrollEvent(event);
                clearInterval(interval);
              }
            }, 0);
          }
          this.noData = res.data[0].nextCount;
          res.data.length > 0 ? this.nextCount.push(res.data[0].nextCount) : (this.nextCount = []);
          if (res.status == 1) {
            if (this.pageNo != 1 && this.search == false) {
                console.log(this.pageNo,"this.pageNo");
            } else {
              this.getLabList = [];
            }

            for (let item of res.data[0].details) {
              let labMedia = item.LabmediaDetails;
              this.getLabListss = item.LabmediaDetails;
              this.getLabList.push(item);
              for (let item1 of labMedia) {
                item1['playMode'] = false;
              }
            }
          }
          this.scrolltop();
          this.refFunc();
          this.infyFunc();
        },
        (err) => {
          console.log(err);
          this.refFunc();
          this.infyFunc();
        }
      );
      this.search = false;
      this.searhFilter = '';
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  searchLab() {
    this.search = true;
    this.pageNo = 1;
    this.showLabListPage(5);
  }

  sorting() {
    this.showProgressBar = true;
    this.offerSoring = true;
    this.rateSoring = false;
    if (this.offrSortOrder == 'ASC') {
      this.offrSortOrder = 'DESC';
    } else if ((this.offrSortOrder = 'DESC')) {
      this.offrSortOrder = 'ASC';
    }
    this.pageNo = 1;
    this.showLabListPage(6);
  }

  // rateSort() {
  //   this.showProgressBar = true;
  //   this.rateSoring = true;
  //   this.offerSoring = false;
  //   if (this.rateSortOrder == 'ASC') {
  //     this.rateSortOrder = 'DESC';
  //   } else if ((this.rateSortOrder = 'DESC')) {
  //     this.rateSortOrder = 'ASC';
  //   }
  //   this.pageNo = 1;
  //   this.showLabListPage(7);
  // }

  async rateSort() {
    const alert = await this.modalCtrl.create({
      component: RatingSortpagePage,
      showBackdrop: true,
      cssClass: 'rating_sort_page_doctor',
      backdropDismiss: false,
      componentProps: {
        frm: 'Lab',
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      console.log(data.data.orderWise, 'and', data.data.orderby);
      if (data.data.orderWise != null) {
        this.pageNo = 1;
        this.getLabList = [];
        if (data.data.orderby == 'Rating') {
          this.showProgressBar = true;
          this.rateSoring = true;
          this.offerSoring = false;
          this.rateSortOrder = data.data.orderWise;
          this.showLabListPage(7);
        }
      }
    });
    await alert.present();
  }


  sltProfile: any;
  showcoment: boolean = false;
  workinghrs: any;
  mediadetails_lab: any = [];
  selectLab(labId, frmpage, patient_id) {
    debugger;
    this.currentPlaying?.pause();
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.isShowHeaderValue = true;
    this.headerValue = this.addCall.title745;
    this.commonheadervalueData = true;
    this.ChangeEvent.emit('profile');
    this.commonheadervalue = 'Lab';
    this.show_testbut = false;
    this.reShdulBtnValue = frmpage;
    this.workinghrs = [];
    this.storeWorkingHours = [];
    this.showcoment = false;
    this.isShow = true;
    this.particularLab = null;
    this.mediadetails_lab = [];
    let getDate = new Date();
    this.currentDate = getDate.getFullYear() + '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) +  '-' + ('0' + getDate.getDate()).slice(-2);
    this.storeLabId = labId;
    this.presentView = 'selectedLabPage';
    this.labProfile = true;
    this.bookingPage = false;
    this.bookingConformPage = false;
    this.reviewCmt = [];
    this.reviewCommand = [];
    let apiData = JSON.stringify({
      currentDate: this.currentDate,
      labId: labId,
      patientId: localStorage.getItem('patient_id'),
      lat: this.lattitude,
      long: this.longititude
    });
    this.services
      .postRequest('getParticularLabdetails', apiData)
      .subscribe((res) => {
        debugger;
        if (res.status == 1) {
          this.particularLab = res.data[0];
          this.LabAddress = this.particularLab.vendor_address;
          if (res.data[0].review_comment) {
            if (JSON.parse(this.particularLab.review_comment).length > 1) {
              this.reviewCmt = JSON.parse(this.particularLab.review_comment);
            } else{
              this.reviewCmt = JSON.parse(this.particularLab.review_comment);
            }
            this.reviewCommand = JSON.parse(this.particularLab.review_comment)[0];
            this.commentlength = JSON.parse(this.particularLab.review_comment).length;
          } else {
            this.reviewCmt = [];
            this.reviewCommand = [];
            this.commentlength = 0;
          }
          console.log("Review Comments - ", this.reviewCmt,this.reviewCommand);
          this.storeLabName = this.particularLab.Lab;
          this.sltProfile = this.particularLab.vendor_profile_path;

          for (let item of this.particularLab.Labworkinghours) {
            this.storeWorkingHours.push({
              timing: item.wh_fromtime + '-' + item.wh_totime,
              wh_weekday: item.wh_weekday,
              wh_fromtime: item.wh_fromtime,
              wh_totime: item.wh_totime,
            });
          }

          const groupedMap = this.storeWorkingHours.reduce(
            (entryMap, e) =>
              entryMap.set(e.timing, [
                ...(entryMap.get(e.timing) || []),
                e.wh_weekday.substr(0, 3),
              ]),
            new Map()
          );
          console.log(groupedMap);
          this.workinghrs = Array.from(groupedMap);
        }

        let temparray = [];
        for (let item of this.particularLab.LabmediaDetails) {
          temparray.push(item);
          if (temparray.length === 3) {
            this.mediadetails_lab.push(temparray);
            temparray = [];
          }
        }
        if (temparray.length > 0) {
          this.mediadetails_lab.push(temparray);
        }

        if (frmpage == 'labprofile') {
          this.frmreferral_page = false;
          this.storeSelectedLapTestConverted = [];
          this.backValue = 'goLabList';
          this.bookref_id = 0;
        } else if (frmpage == 'Reschedule') {
          this.headerValue = this.addCall.title50;
          this.bookref_id = 0;
          this.Booking('reschedule');
        } else if (frmpage == 'Repeat') {
          this.headerValue = this.addCall.title94;
          this.bookref_id = 0;
          this.Booking('repeat');
        } else if (frmpage == 'referralpage') {
          this.headerValue = this.addCall.title370;
          this.patientbasicdetails();
          this.frmreferral_page = true;
          this.backValue = 'Referral';
          this.Booking('Referral');
        } else if (frmpage == 'deal') {
          debugger;
          this.headerValue = this.addCall.title603;
          debugger;
          let patientIdCheck;

          if (
            this.reShdulBtnValue == 'Reschedule' ||
            this.reShdulBtnValue == 'Repeat'
          ) {
            patientIdCheck = this.familyMemId;
          } else if (this.headerValue == 'Referral') {
            patientIdCheck = this.storeMemberPatientId;
          } else {
            patientIdCheck = localStorage.getItem('patient_id');
          }

          let getDate = new Date();
          this.currentDate = getDate.getFullYear() + '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) +  '-' +   ('0' + getDate.getDate()).slice(-2);
          this.currentTime = new Date().toTimeString().split(' ')[0];

          let apiData2 = JSON.stringify({
            patientId: patientIdCheck,
            currentDate: this.currentDate,
            currentTime: this.currentTime,
          });
          this.services
            .postRequest('getPatientProfile', apiData2)
            .subscribe((res) => {
              console.log(res, '1884');
              if (res.status == 1) {
                this.patientDetails = res.data[0];
                this.storePatientName = this.patientDetails.name;
                this.Email = this.patientDetails.email;
                this.Phoneno = this.patientDetails.phone_no;
                setTimeout(() => {
                  document.getElementById('nameInput').style.width = this.storePatientName.length + 2 + 'ch';
                }, 500);
              }
            });
          this.Booking('deal');
          this.bookref_id = 0;
          this.backValue = 'goLabList';
        } else if (frmpage == 'referralpage1') {
          this.frmreferral_page = false;
          this.bookref_id = 0;
          this.storeSelectedLapTestConverted = [];
          this.backValue = 'Referral';
        }
      });
  }

  catlist: any;
  getLabPakgeList(frm) {
    if (this.catlist) {
      this.catlist.unsubscribe();
    }

    this.labTestPakage = [];
    let apiData = JSON.stringify({
      labId: this.storeLabId,
      searchcontent: this.searchValue1,
    });
    this.catlist = this.services
      .postRequest('getLabpackageType', apiData)
      .subscribe(async (res) => {
        for (let item of res.data) {
          await this.labTestPakage.push({
            labTestCategoryId: item.labTestCategoryId,
            lab_test_category: item.lab_test_category,
            testcount: item.testcount,
            testdetarrow: false,
            labSubTestList: null,
            category_filepath: item.category_filepath,
          });
        }

        if (frm == 'reschedule' || frm == 'repeat' || frm == 'Referral' ||  frm == 'deal') {
          this.labTestPakage.forEach((item) => {
            this.getLabTest(item.labTestCategoryId);
          });
        }
      });
  }

  testcategory: any;
  convertArabicDateFormat(dateString) {
    const months = {
      يناير: '01',
      فبراير: '02',
      مارس: '03',
      أبريل: '04',
      مايو: '05',
      يونيو: '06',
      يوليو: '07',
      أغسطس: '08',
      سبتمبر: '09',
      أكتوبر: '10',
      نوفمبر: '11',
      ديسمبر: '12',
    };

    const parts = dateString.split('-');
    const day = parts[0].trim();
    const month = months[parts[1].trim()];
    const year = parts[2].trim();
    return `${year}-${month}-${day}`;
  }

  getlabpackage_test() {
    debugger;
    this.labTestPakage = [];
    this.labSubTestList = [];

    if (this.reShdulBtnValue == 'labprofile') {
      this.testslt = [];
      this.tstmngID = [];
      this.testIdlist = [];
    }

    let apiData = JSON.stringify({
      labId: this.storeLabId,
      searchcontent: this.searchValue1,
      dateValue: formatDate(this.Date, 'YYYY-MM-dd', 'en-us'),
    });

    if (this.testcategory) {
      this.testcategory.unsubscribe();
    }

    this.testcategory = this.services
      .postRequest('getLabpackageandtest', apiData)
      .subscribe(async (res) => {
        debugger;
        for (let item of res.data) {
          this.labTestPakage.push({
            labTestCategoryId: item.labTestCategoryId,
            lab_test_category: item.lab_test_category,
            testcount: item.testcount,
            testdetarrow: false,
            labSubTestList: null,
            category_filepath: item.category_filepath,
          });

          for (let i of JSON.parse(item.list)) {
            this.labSubTestList.push({
              testId: i.test_id,
              testName: i.lab_test_name,
              dealsDetails: JSON.parse(i.deal_details),
              cost: i.cost,
              instuction: i.instruction,
              selected: false,
              nonselect: false,
              catid: i.cat_Id,
            });
          }

          if (this.tstmngID.length > 0) {
            this.tstmngID.forEach((i) => {
              this.labSubTestList.forEach((items) => {
                if (i == items.testId) {
                  items['selected'] = true;
                }
              });
            });
          }

          this.labTestPakage.forEach((item) => {
            this.labSubTestList.forEach((i) => {
              if (i.dealsDetails == null) {
                i.dealsDetails = [];
              }
              if (item.labTestCategoryId == i.catid) {
                item.labSubTestList = this.labSubTestList;
              }
            });
          });

          this.labSubTestList = [];
        }
      });
  }

  malformedJSON2Array(tar) {
    let tmp = [];
    if (tar) {
      tar = tar.replace(/^\{|\}$/g, '').split(',');

      for (let i = 0, cur, pair; (cur = tar[i]); i++) {
        pair = cur.split(':');
        tmp[i] = /^\d*$/.test(pair[1]) ? +pair[1] : pair[1];
      }
    }
    return tmp;
  }

  searchCatandTest(eve) {
    if (this.searchValue1.length > 3 || this.searchValue1.length == 0) {
      this.getlabpackage_test();
    }
  }

  Booking(frmpage) {
    debugger;
    this.searchValue1 = '';
    // this.Date = new Date();
    this.testslt = [];
    this.testIdlist = [];
    this.tstmngID = [];
    this.TotalCost = 0;
    this.isDateSel = false;
    this.testId = null;
    this.labSubTestList = [];
    this.instList = [];
    this.presentView = 'selectedLabPage';
    this.bookingPage = true;
    this.labProfile = false;
    this.bookingConformPage = false;
    this.EmptyLabStest = true;
    if (frmpage == 'Labprofile') {
      this.headerValue = this.storeLabName;
      this.backValue = 'goLabInfo';
      this.getlabpackage_test();
    } else if (frmpage == 'reschedule') {
      this.headerValue = this.addCall.title50;
      this.backValue = 'goBookingList';
      this.getLabPakgeList(frmpage);
    } else if (frmpage == 'repeat') {
      this.backValue = 'goCancelBookingList';
      this.getLabPakgeList(frmpage);
    } else if (frmpage == 'Referral') {
      this.getDate = null;
      this.getTime = null;
      this.chsApmntDate = null;
      this.chsApmntTime = null;
      this.backValue = 'Referral';
      this.getLabPakgeList(frmpage);
    } else if (frmpage == 'deal') {
      this.backValue = 'goLabInfo';
      this.getLabPakgeList(frmpage);
    }
  }

  labSubTest() {
    console.log('brfore -> ', this.testId);
    if (this.isDateSel == true) {
      if (
        this.testId != '' &&
        this.testId != null &&
        this.testId != undefined
      ) {
        this.getLabTest(this.testId);
      }
    } else {
      this.testId = '';
      this.presentToast(this.addCall.title593);
    }
    console.log('After -> ', this.testId);
  }
  labSubTestList1: any = [];

  getLabTest(testid) {
    this.EmptyLabStest = false;
    this.labSubTestList = [];
    this.labSubTestList1 = [];
    let apiData = JSON.stringify({
      currentDate: this.currentDate,
      labId: this.storeLabId,
      labcategoryId: String(testid),
    });
    this.services.postRequest('getLabtest', apiData).subscribe(async (res) => {
      this.EmptyLabStest = true;
      this.TotalCost = 0;
      for (let item of res.data) {
        this.labSubTestList.push({
          testId: item.testId,
          testName: item.testName,
          dealsDetails: item.dealsDetails,
          cost: item.cost,
          instuction: item.instuction,
          selected: false,
          nonselect: false,
          catid: null,
        });

        this.labSubTestList1.push({
          testId: item.testId,
          testName: item.testName,
          dealsDetails: item.dealsDetails,
          cost: item.cost,
          instuction: item.instuction,
          selected: false,
          nonselect: false,
        });
      }

      if (this.reShdulBtnValue == 'Reschedule') {
        this.labSubTestList.forEach((i) => {
          this.storeSelectedLapTestConverted.forEach((j) => {
            if (i.testId == j.lab_test_id) {
              i.selected = true;
              i.nonselect = true;
              this.testslt.push(i);
            }
          });
        });

        console.log(this.testslt);
        this.testList();
      }

      if (this.reShdulBtnValue == 'Repeat') {
        console.log('repat flow');
        console.log(this.storeSelectedLapTestConverted);

        this.labSubTestList.forEach((i) => {
          this.storeSelectedLapTestConverted.forEach((j) => {
            if (i.testId == j.lab_test_id) {
              console.log('check true');
              i.selected = true;
              i.nonselect = false;
              this.testslt.push(i);
            }
          });
        });
        let actualamt = 0;
        this.TotalCost = 0;

        for (let item of this.testslt) {
          const fromDate = new Date(this.Date);

          if (item.dealsDetails.length > 0) {
            const dealValidFrom = new Date(
              item.dealsDetails[0].deal_valid_from
            );
            const dealValidTo = new Date(item.dealsDetails[0].deal_valid_to);

            const fromDateWithoutTime = new Date(
              fromDate.getFullYear(),
              fromDate.getMonth(),
              fromDate.getDate()
            );
            const dealValidFromWithoutTime = new Date(
              dealValidFrom.getFullYear(),
              dealValidFrom.getMonth(),
              dealValidFrom.getDate()
            );
            const dealValidToWithoutTime = new Date(
              dealValidTo.getFullYear(),
              dealValidTo.getMonth(),
              dealValidTo.getDate()
            );

            if (
              dealValidFromWithoutTime <= fromDateWithoutTime &&
              fromDateWithoutTime <= dealValidToWithoutTime
            ) {
              if (item.dealsDetails[0].deal_options === 'Amount') {
                actualamt =
                  Number(item.cost) - Number(item.dealsDetails[0].deal_amount);
              } else if (item.dealsDetails[0].deal_options === 'Percentage') {
                actualamt =
                  Number(item.cost) -
                  (Number(item.cost) *
                    Number(item.dealsDetails[0].deal_amount)) /
                  100;
              }
            } else {
              actualamt = Number(item.cost);
            }

            this.TotalCost += actualamt;
            this.TotalCost = Number(this.TotalCost.toFixed(3));
          } else {
            this.TotalCost += Number(item.cost.toFixed(3));
          }
        }
        this.testList();
      }

      if (this.reShdulBtnValue == 'referralpage') {
        console.log(this.storeSelectedLapTestConverted);
        this.labSubTestList.forEach((i) => {
          this.referrealtestid.forEach((j) => {
            if (i.testId == j.lab_test_id) {
              i.selected = true;
              i.nonselect = false;
              this.testslt.push(i);
            }
          });
        });
        this.TotalCost = 0;
        let actualamt = 0;
        for (let item of this.testslt) {
          const fromDate = new Date(this.Date);

          if (item.dealsDetails.length > 0) {
            const dealValidFrom = new Date(
              item.dealsDetails[0].deal_valid_from
            );
            const dealValidTo = new Date(item.dealsDetails[0].deal_valid_to);

            const fromDateWithoutTime = new Date(
              fromDate.getFullYear(),
              fromDate.getMonth(),
              fromDate.getDate()
            );
            const dealValidFromWithoutTime = new Date(
              dealValidFrom.getFullYear(),
              dealValidFrom.getMonth(),
              dealValidFrom.getDate()
            );
            const dealValidToWithoutTime = new Date(
              dealValidTo.getFullYear(),
              dealValidTo.getMonth(),
              dealValidTo.getDate()
            );

            if (
              dealValidFromWithoutTime <= fromDateWithoutTime &&
              fromDateWithoutTime <= dealValidToWithoutTime
            ) {
              if (item.dealsDetails[0].deal_options === 'Amount') {
                actualamt =
                  Number(item.cost) - Number(item.dealsDetails[0].deal_amount);
              } else if (item.dealsDetails[0].deal_options === 'Percentage') {
                actualamt =
                  Number(item.cost) -
                  (Number(item.cost) *
                    Number(item.dealsDetails[0].deal_amount)) /
                  100;
              }
            } else {
              actualamt = Number(item.cost);
            }

            this.TotalCost += actualamt;
            this.TotalCost = Number(this.TotalCost.toFixed(3));
          } else {
            this.TotalCost += Number(item.cost.toFixed(3));
          }
        }
        this.testList();
      }

      if (this.showoffertest == true) {
        this.labSubTestList.forEach((i) => {
          this.dealdetaild.forEach((j) => {
            if (i.testId == j.lab_test_id) {
              console.log('check true');
              i.selected = true;
              i.nonselect = false;
              this.testslt.push(i);
            }
          });
        });
        this.TotalCost = 0;

        for (let item of this.testslt) {
          let actualamt = 0;
          console.log('total amout for refferal');
          if (item.dealsDetails.length > 0) {
            if (item.dealsDetails[0].deal_options == 'Amount') {
              actualamt =
                Number(item.cost) - Number(item.dealsDetails[0].deal_amount);
            } else if (item.dealsDetails[0].deal_options == 'Percentage') {
              actualamt =
                Number(item.cost) -
                (Number(item.cost) * Number(item.dealsDetails[0].deal_amount)) /
                100;
            }
          } else {
            actualamt = Number(item.cost);
          }
          this.TotalCost = this.TotalCost + actualamt;
          this.TotalCost = Number(this.TotalCost.toFixed(3));
        }

        this.testList();
      }

      this.labTestPakage.forEach((item) => {
        if (item.labTestCategoryId == testid) {
          item.labSubTestList = this.labSubTestList;
          this.labSubTestList.forEach((i) => {
            if (i.selected == true) {
              item.testdetarrow = true;
            }
          });
        }
      });
      this.labSubTestList = [];
      this.labSubTestList1 = [];
    });
  }

  dateValidation(getDayId) {
    let day = this.days[getDayId];
    let status = false;
    for (let item of this.storeWorkingHours) {
      if (item.wh_weekday == day) {
        status = true;
        console.log('statysDatewh_weekday', status);
      }
    }
    console.log('statysDate', status);

    if (status == false && this.frmreferral_page == false) {
      this.Date = null;
      this.getDate = null;
      this.presentToast(this.addCall.title678);
    }
  }

  is_Reschedulechangetime: boolean = false;
  timeValidation() {
    debugger;
    this.chsApmntTime = null;
    this.is_Reschedulechangetime = false;
    console.log('DATE -> ', this.getDate);
    console.log('Get Time -> ', this.getTime);
    let _obj = this;
    let curDT = new Date().toISOString().split('T')[0];
    let day = new Date(this.chsApmntDate).getDay();
    let days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

    let min = new Date();
    min.setTime(min.getTime() + 0);
    let CT = min.toTimeString().split(' ')[0];

    if (this.getDate != null) {
      if (this.getTime && this.storeWorkingHours.length != 0) {
        console.log(this.getTime, 'get time =>', typeof this.getTime);

        if (this.reShdulBtnValue != 'Reschedule') {
          var time = this.getTime;
        } else {
          var time = this.getTime;
          this.chsApmntTime = time;
          this.is_Reschedulechangetime = true;
        }

        this.getlabpackage_test();
        console.log(String(time));

        let working_hours = this.storeWorkingHours.filter(
          (data) => data.wh_weekday == days[day]
        );
        let workinghrs_status = false;

        for (let item of working_hours) {
          console.log(item);
          let formatFromTime = item.wh_fromtime.split('.')[0];
          let formatToTime = item.wh_totime.split('.')[0];
          if (
            formatFromTime.split(':')[0] + ':' + formatFromTime.split(':')[1] <=
            String(time) &&
            formatToTime.split(':')[0] + ':' + formatToTime.split(':')[1] >=
            String(time)
          ) {
            workinghrs_status = true;
            break;
          }
        }
        if (this.chsApmntDate === curDT && time <= CT) {
          console.log(this.chsApmntDate, '==', curDT);
          setTimeout(() => {
            _obj.getTime = '';
          }, 100);
          this.presentToast(
            this.addCall.title746 + " " +
            this.getFormattedDateTime(CT, 'Time') +
            ' !'
          );
        } else if (workinghrs_status == false) {
          setTimeout(() => {
            _obj.getTime = '';
          }, 100);
          this.presentToast(this.addCall.title679);
        } else {
          this.chsApmntTime = String(time);
          if (this.reShdulBtnValue == 'Reschedule') {
            console.log(time, 'resc time change');
            let showtimer = String(time);
            this.chsApmntTime = showtimer;
          }
        }
      }
    } else {
      setTimeout(() => {
        _obj.getTime = '';
      }, 100);
      this.presentToast('Please Select Date');
    }
    console.log(this.chsApmntTime, 'selected time');
  }
  Email: any;
  Phoneno: any;

  allowbooking(val: any) {
    debugger;
    this.isConfirmed = false;
    this.pagechk = val;
    if (this.reShdulBtnValue == 'Reschedule' && this.bookingPage == true) {
      if (this.chsApmntTime === this.oldbookingtime) {
        console.log('check true');
        this.presentToast('No changes found');
      } else {
        console.log(
          'check false',
          this.chsApmntTime,
          '==',
          this.oldbookingtime
        );
        this.AddBooking('firstBooking');
      }
    } else {
      this.AddBooking('firstBooking');
    }
  }

  AddBooking(flowValue) {
    debugger;
    console.log(this.chsApmntDate, this.chsApmntTime);

    console.log(this.backtobooklist, 'test reschedule btn');

    let patientIdCheck;

    if (
      this.reShdulBtnValue == 'Reschedule' ||
      this.reShdulBtnValue == 'Repeat'
    ) {
      patientIdCheck = this.familyMemId;
    } else if (this.headerValue == 'Referral') {
      patientIdCheck = this.storeMemberPatientId;
    } else {
      patientIdCheck = localStorage.getItem('patient_id');
    }

    if (this.chsApmntDate != null && this.chsApmntTime != null) {
      this.testList();
      let getDate = new Date();
      this.currentDate =
        getDate.getFullYear() +
        '-' +
        ('0' + (getDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + getDate.getDate()).slice(-2);
      this.currentTime = new Date().toTimeString().split(' ')[0];
      if (this.chsApmntDate && this.chsApmntTime) {
        this.presentView = 'selectedLabPage';
        this.storeFlowValue = flowValue;
        this.bookingPage = false;
        this.labProfile = false;
        this.bookingConformPage = true;
        this.headerValue = this.addCall.title40;

        let apiData2 = JSON.stringify({
          patientId: patientIdCheck,
          currentDate: this.currentDate,
          currentTime: this.currentTime,
        });
        this.services
          .postRequest('getPatientProfile', apiData2)
          .subscribe((res) => {
            console.log(res, '1770');
            if (res.status == 1) {
              this.patientDetails = res.data[0];
              this.storePatientName = this.patientDetails.name;
              this.Email = this.patientDetails.email;
              this, (this.Phoneno = this.patientDetails.phone_no);
              setTimeout(() => {
                document.getElementById('nameInput').style.width = this.storePatientName.length + 2 + 'ch';
              }, 500);
            }
          });

        if (flowValue === 'firstBooking') {
          this.backValue = 'goBooking';
          console.log(this.testslt);

          this.TotalCost = 0;
          let actualamt = 0;
          this.storeSelectedLapTestConverted = [];

          for (let item of this.testslt) {
            const fromDate = new Date(this.Date);

            if (item.dealsDetails.length > 0) {
              console.log(item.dealsDetails[0].deal_options);

              const dealValidFrom = new Date(
                item.dealsDetails[0].deal_valid_from
              );
              const dealValidTo = new Date(item.dealsDetails[0].deal_valid_to);

              const fromDateWithoutTime = new Date(
                fromDate.getFullYear(),
                fromDate.getMonth(),
                fromDate.getDate()
              );
              const dealValidFromWithoutTime = new Date(
                dealValidFrom.getFullYear(),
                dealValidFrom.getMonth(),
                dealValidFrom.getDate()
              );
              const dealValidToWithoutTime = new Date(
                dealValidTo.getFullYear(),
                dealValidTo.getMonth(),
                dealValidTo.getDate()
              );

              if (
                dealValidFromWithoutTime <= fromDateWithoutTime &&
                fromDateWithoutTime <= dealValidToWithoutTime
              ) {
                if (item.dealsDetails[0].deal_options === 'Amount') {
                  actualamt =
                    Number(item.cost) -
                    Number(item.dealsDetails[0].deal_amount);
                } else if (item.dealsDetails[0].deal_options === 'Percentage') {
                  actualamt =
                    Number(item.cost) -
                    (Number(item.cost) *
                      Number(item.dealsDetails[0].deal_amount)) /
                    100;
                  console.log(actualamt);
                } else {
                  actualamt = Number(item.cost);
                }

                this.storeSelectedLapTestConverted.push({
                  lab_test_id: item.testId,
                  test_amount: actualamt,
                  deal_id:
                    item.dealsDetails[0].id == undefined
                      ? item.dealsDetails[0].deal_id
                      : item.dealsDetails[0].id,
                  deal_option: item.dealsDetails[0].deal_options,
                  deal_amount: item.dealsDetails[0].deal_amount,
                  actualamt: item.cost,
                });
              } else {
                actualamt = Number(item.cost);

                this.storeSelectedLapTestConverted.push({
                  lab_test_id: item.testId,
                  test_amount: actualamt,
                  deal_id: null,
                  deal_option: null,
                  deal_amount: 0,
                  actualamt: item.cost,
                });
              }
            } else {
              actualamt = Number(item.cost);

              this.storeSelectedLapTestConverted.push({
                lab_test_id: item.testId,
                test_amount: actualamt,
                deal_id: null,
                deal_option: null,
                deal_amount: 0,
                actualamt: item.cost,
              });
            }

            this.storeSelectedLapTest = [];

            for (let item of this.instList) {
              if (item.selected) {
                this.storeSelectedLapTest.push({
                  testId: item.testId,
                  testName: item.testName,
                  test_amount: item.cost,
                });
              }
            }

            this.TotalCost += actualamt;
            this.TotalCost = Number(this.TotalCost.toFixed(3));
          }

          // this.currentMemberId = localStorage.getItem('patient_id');
        } else if (flowValue == 'repeatBooking') {
          this.backValue = 'goReBookingPage';
          this.ChangeEvent.emit('isLabBack');
          this.isShowHeaderValue = false;
        }
      } else {
        if (this.TotalCost == 0) {
          this.presentToast('At least one test must be selected');
        }
      }
    } else if (this.chsApmntDate == null) {
      this.presentToast(this.addCall.title593);
    } else if (this.chsApmntTime == null) {
      this.presentToast(this.addCall.title594);
    }
  }

  patientbasicdetails() {
    debugger;
    let patientIdCheck;

    if (
      this.reShdulBtnValue == 'Reschedule' ||
      this.reShdulBtnValue == 'Repeat'
    ) {
      patientIdCheck = this.familyMemId;
    } else if (this.headerValue == 'Referral') {
      patientIdCheck = this.storeMemberPatientId;
    } else {
      patientIdCheck = localStorage.getItem('patient_id');
    }

    let getDate = new Date();
    this.currentDate = getDate.getFullYear() + '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) +  '-' +   ('0' + getDate.getDate()).slice(-2);
    this.currentTime = new Date().toTimeString().split(' ')[0];

    let apiData2 = JSON.stringify({
      patientId: patientIdCheck,
      currentDate: this.currentDate,
      currentTime: this.currentTime,
    });
    this.services
      .postRequest('getPatientProfile', apiData2)
      .subscribe((res) => {
        console.log(res, '1884');
        if (res.status == 1) {
          this.patientDetails = res.data[0];
          this.storePatientName = this.patientDetails.name;
          this.Email = this.patientDetails.email;
          this.Phoneno = this.patientDetails.phone_no;
          setTimeout(() => {
            document.getElementById('nameInput').style.width = this.storePatientName.length + 2 + 'ch';
          }, 500);
        }
      });
  }

  changePatient(getPatientName, memId) {
    console.log(getPatientName, memId);

    this.storePatientName = getPatientName;
    this.currentMemberId = memId;
    document.getElementById('nameInput').style.width = this.storePatientName.length + 2 + 'ch';
  }

  getLenth() {
    document.getElementById('nameInput').style.width = this.storePatientName.length + 2 + 'ch';
  }

  async addMember() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: '',
        getMemGender: '',
        getMemReletion: '',
        getMemHeight: '',
        getMemWeight: '',
        getMemMobileNo: '',
        membDOB: '',
        getMemDob: '',
        memProImg: '',
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      console.log(res);
      if (res.data.from == 2) {
        this.AddBooking(this.storeFlowValue);
      }
    });
    return await modal.present();
  }

  getPatientReletion() {
    this.services.getRequest('getpatientrelation').subscribe((res) => {
      console.log(res);
      this.reletionList = res.data;
    });
  }

  async paymentgate() {
    debugger;
    console.log(
      this.storePatientName,
      this.Email,
      this.Phoneno,
      this.TotalCost
    );
    console.log(this.bookref_id, 'referral bookin  id');
    console.log(this.storeSelectedLapTestConverted, 'testdetails');
    if (this.TotalCost > 0) {
      await this.presentModal1();
    }
  }

  IpAddress() {
    this.httpClient.get('https://jsonip.com').subscribe(
      (value: any) => {
        console.log(value);
        this.userIP = value.ip;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  gatewayFunction(res: any, paymentGateway: any) {
    if (res.status == '1') {
      this.proceedToPay(res);
      this.paymentid = res.resultid;
      this.referenceid = res.sessionid;
      this.order_Id = res.orderId;
      this.paymentGatewayName = res.paymentGatewayName;
      this.ChangeEvent.emit('isLabBack');
      this.isShowHeaderValue = false;
    } else if (res.status == '2') {
      this.AlertInfo('Payment Canceled', 0);
    } else {
      console.log('payment failed');
      if(paymentGateway=="KNET"){
        this.showKnetPaymentDetals(res, this.addCall.title655);
      } else {
        this.AlertInfo('Payment Canceled', 0);
      }
    }
  }

  async proceedToPay(response: any) {
    localStorage.setItem('payBack', 'lab');
    let isMember = 0;
    console.log(this.chsApmntTime);

    const loading = await this.loadingController.create({
      message: 'Processing Your Payment Status',
    });
    await loading.present();
    console.log('=> next booking API');
    let total_amount = this.TotalCost;
    let roundedTotalAmount = Number(total_amount.toFixed(3));
    let apiData = JSON.stringify({
      patientId: this.currentMemberId
        ? this.currentMemberId
        : localStorage.getItem('patient_id'),
      lab_vendor_id: this.storeLabId,
      test_date: this.chsApmntDate,
      test_time: this.chsApmntTime,
      total_amount: roundedTotalAmount,
      paymentStatus: '1',
      isMember: isMember,
      tempMemberName: this.storePatientName,
      test: this.storeSelectedLapTestConverted,
      oldBookingId: 0,
      paymentid: this.paymentid,
      referenceid: this.referenceid,
      refbook_Id: this.bookref_id,
      orderid: this.order_Id,
      paymentGateway: this.paymentGatewayName,
      ip_address: this.userIP,
    });
    this.services
      .postRequest('patientLabBooking', apiData)
      .subscribe(async (res) => {
        console.log(res);
        this.loadingController.dismiss();
        if (res.status) {
          setTimeout(() => {
            this.playSound();
          }, 1000);
          if (localStorage.getItem('cardType') == 'Knet') {
            this.showKnetPaymentDetals(response, this.addCall.title620);
          } else if (localStorage.getItem('cardType') == 'MasterCard') {
            this.router.navigate(['/payment', { paymentstatus: 1 }]);
          }
        } else {
          this.Alertpopup(res.msg, res.status);
        }
      });
  }

  playSound() {
    let audio = new Audio();
    audio.src = '../assets/audio/tick.mp3';
    audio.load();
    audio.play();
  }

  wayOfBookingListpages(page) {
    this.StoreWayBookingPageFlow = page;
    this.pageNo = 1;
    this.EmtyData = null;
    if (page == 'bookingList') {
      this.bookingListData = [];
      this.bookingList();
    } else if (page == 'bookingHisList') {
      this.bookingHistoryList = [];
      this.bookingHis();
    }
  }

  bookingList() {
    this.showcoment = false;
    this.nextbookinglistcount = null;
    try {
      this.presentView = 'HistoryPage';
      this.canceldBookingIcon = true;
      this.viewBookingList = true;
      this.viewBookingInfo = false;
      this.viewCanceledBookingList = false;
      this.viewCancelBookingInfo = false;
      this.backValue = 'goLabList';
      this.headerValue = this.addCall.title143;


      let getDate = new Date();
      let getTime = new Date().toTimeString().split(' ')[0];
      let convertDate = getDate.getFullYear() + '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) + '-' + ('0' + getDate.getDate()).slice(-2);
      this.checkCrnTime = convertDate + 'T' + getTime;

      if (this.pageNo == 1) {
        this.EmtyData = null;
      }
      let apiData = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        limit: 10,
        pageno: this.pageNo,
      });
      this.services.postRequest('getlabbookinglist', apiData).subscribe(
        (res) => {
          console.log(res, 'lablist');
          this.nextbookinglistcount = res.data[0]?.nextCount;
          this.EmtyData = res.status;
          console.log(this.EmtyData);

          let nextCount;
          res.status == 1
            ? (nextCount = res.data[0].nextCount)
            : (nextCount = 0);
          if (this.scrollEvent) {
            this.scrollEvent.target.disabled = nextCount == 0 ? true : false;
          }
          if (res.status == 1) {
            console.log(this.pageNo);

            if (this.pageNo != 1) {
              for (let item of res.data[0].details) {
                let testDateTime =
                  item.test_date.split('T')[0] + 'T' + item.test_time;
                console.log(testDateTime < this.checkCrnTime);

                if (new Date(testDateTime) > new Date(this.checkCrnTime)) {
                  item['timeStatus'] = true;
                } else {
                  item['timeStatus'] = false;
                }
                this.bookingListData.push(item);
              }
            } else {
              this.bookingListData = [];
              for (let item of res.data[0].details) {
                this.p_Name = item.patientName;
                let testbookdate = formatDate(
                  item.test_date,
                  'YYY-MM-dd',
                  'en-us'
                );
                let testDateTime = testbookdate + 'T' + item.test_time;
                if (new Date(testDateTime) > new Date(this.checkCrnTime)) {
                  item['timeStatus'] = true;
                } else {
                  item['timeStatus'] = false;
                }

                this.bookingListData.push(item);
              }
            }
          }
          this.refFunc();
          this.infyFunc();
        },
        (err) => {
          this.refFunc();
          this.infyFunc();
        }
      );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  showtestname: any = [];
  showtestamt: any = [];

  viewBookingDetail(index) {
    debugger;
    this.commonheadervalue = 'Lab';
    this.commonheadervalueData = true;
    this.isShowHeaderValue = true;
    this.ChangeEvent.emit('profile');
    this.headerValue = '';

    this.showtestname = [];
    this.showtestamt = [];
    this.canceldBookingIcon = false;
    this.viewBookingInfo = true;
    this.viewBookingList = false;
    this.viewCanceledBookingList = false;
    this.viewCancelBookingInfo = false;
    this.backValue = 'goBookingList';
    this.typeid = 1;
    this.headerValue = this.addCall.title133;
    this.particularBkgData = this.bookingListData[index];
    this.particularBkgData.LabBookedTestData.forEach((i) => {
      this.showtestname.push(i.lab_test_name);
      this.showtestamt.push(i);
    });
    console.log('test item =>', this.showtestname);
  }

  async cancelBkg(bookingId, bookingAmnt) {
    this.storeBookingId = bookingId;
    this.bookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt,
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      console.log(res);
      if (res.data != null) {
        this.presentLoading();
        this.cancelBookingApi();
      }
    });
    return await modal.present();
  }

  cancelBookingApi() {
    let apiData = JSON.stringify({
      cancelstatus: '1',
      labbookingId: this.storeBookingId,
      patientId: localStorage.getItem('patient_id'),
    });
    this.services.postRequest('Cancellabbooking', apiData).subscribe((res) => {
      console.log(res);
      if (res) this.pageNo = 1;
      this.EmtyData = null;
      this.bookingListData = [];
      this.bookingList();
      this.loadingController.dismiss();
      this.loadingController.dismiss();

      if (res.data[0].msgcode == 1) {
        this.AlertInfo(this.addCall.title449, res.status);
      } else if (res.data[0].msgcode == 2) {
        this.AlertInfo(this.addCall.title450, res.status);
      } else if (res.data[0].msgcode == 3) {
        this.AlertInfo(this.addCall.title451, 0);
      }
    });
  }

  bookingHis() {
    this.nextbookinglistcount = null;
    try {
      this.presentView = 'HistoryPage';
      this.canceldBookingIcon = false;
      this.viewBookingInfo = false;
      this.viewBookingList = false;
      this.viewCanceledBookingList = true;
      this.viewCancelBookingInfo = false;
      this.backValue = 'goBookingList';
      this.headerValue = this.addCall.title134;
      if (this.pageNo == 1) {
        this.EmtyData = null;
      }
      let apiData = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        limit: 10,
        pageno: this.pageNo,
      });
      this.services.postRequest('getlabbookinghistory', apiData).subscribe(
        (res) => {
          console.log(res);
          this.nextbookinglistcount = res.data[0]?.nextCount;
          let nextCount;
          res.status == 1
            ? (nextCount = res.data[0].nextCount)
            : (nextCount = 0);
          if (this.scrollEvent) {
            this.scrollEvent.target.disabled = nextCount == 0 ? true : false;
          }
          if (this.pageNo != 1) {
            for (let item of res.data[0].details) {
              this.bookingHistoryList.push(item);
            }
          } else {
            this.EmtyData = res.status;
            this.bookingHistoryList = [];
            if (res.data.length > 0) {
              for (let item of res.data[0].details) {
                this.bookingHistoryList.push(item);
              }
            }
          }

          this.refFunc();
          this.infyFunc();
        },
        (err) => {
          console.log(err);
          this.refFunc();
          this.infyFunc();
        }
      );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  viewCanBookDetail(index) {
    this.isShowHeaderValue = true;
    this.ChangeEvent.emit('profile');
    this.commonheadervalueData = true;
    this.showtestname = [];
    this.showtestamt = [];
    this.canceldBookingIcon = false;
    this.viewBookingInfo = false;
    this.viewBookingList = false;
    this.viewCanceledBookingList = false;
    this.viewCancelBookingInfo = true;
    this.backValue = 'goCancelBookingList';
    this.headerValue = this.addCall.title135;
    this.particularHisData = this.bookingHistoryList[index];
    this.particularHisData.LabBookedTestData.forEach((i) => {
      this.showtestname.push(i.lab_test_name);
      this.showtestamt.push(i);
    });
    console.log('test item =>', this.showtestname);
  }

  show_alreadypaidamt: any = 0;
  oldbookingid: any = 0;
  oldbookingtime: any;

  showRescadulePage(btnvalue, index, id, patientName) {
    debugger;
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.familyMemId = id;
    this.oldbookingtime = null;
    this.oldbookingid = 0;
    this.showoffertest = false;
    this.storeHisListIndex = index;
    this.canceldBookingIcon = false;
    this.presentView = 'reschedulePage';
    this.reShdulBtnValue = btnvalue;
    this.storeWorkingHours = [];
    this.getDate = null;
    this.getTime = null;
    this.chsApmntDate = null;
    this.chsApmntTime = null;

    switch (this.reShdulBtnValue) {
      case 'Reschedule': {
        this.backValue = 'goBookingList';
        this.patientbasicdetails();

        this.backtobooklist = false;
        this.particularReschData = this.bookingListData[index];
        this.oldbookingid = this.bookingListData[index].labbookingId;
        this.storeLabName = this.particularReschData.Lab;
        this.TotalCost = this.particularReschData.total_amount;
        this.storeLabId = this.particularReschData.labId;

        this.chsApmntDate = this.particularReschData.test_date;
        this.oldbookingtime = this.particularReschData.test_time;
        this.chsApmntTime = this.particularReschData.test_time;

        this.getDate = formatDate(
          this.particularReschData.test_date,
          'dd-MMM-YYY',
          'en-us'
        );
        if (this.addCall.selectedLanguage == 'ea') {
          this.getDate = this.convertArabFormat(this.getDate);
        }
        console.log('getDate-->', this.getDate);
        this.getTime = this.particularReschData.test_time;

        this.storeSelectedLapTestConverted = [];
        let tc = [];
        for (let item of this.particularReschData.LabBookedTestData) {
          this.refPage = true;
          tc.push(item.acutualAmt);
          this.storeSelectedLapTestConverted.push({
            lab_test_id: item.testDetailsId,
            test_amount: item.test_amount,
            deal_id: undefined,
            deal_option: undefined,
            deal_amount: undefined,
            actualamt: undefined,
          });
        }
        this.show_alreadypaidamt = tc.reduce((a, b) => a + b);
        break;
      }

      case 'Repeat': {
        this.patientbasicdetails();
        this.commonheadervalueData = true;
        this.presentView = 'repeatLabData';
        this.backValue = 'goCancelBookingList';
        this.particularReschData = this.bookingHistoryList[index];
        this.storeSelectedLapTestConverted = [];
        for (let item of this.particularReschData.LabBookedTestData) {
          this.storeSelectedLapTestConverted.push({
            lab_test_id: item.testDetailsId,
            test_amount: item.test_amount,
            deal_id: undefined,
            deal_option: undefined,
            deal_amount: undefined,
            actualamt: undefined,
          });
        }

        this.storeLabName = this.particularReschData.Lab;
        this.TotalCost = this.particularReschData.total_amount;
        this.storeLabId = this.particularReschData.labId;
        break;
      }
    }

    this.selectLab(this.storeLabId, btnvalue, '');
  }

  convertArabFormat(dateString) {
    const monthNamesArabic = [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر',
    ];

    // Split the date string into day, month, and year
    const parts = dateString.split('-');
    const day = parts[0];
    const monthAbbreviation = parts[1];
    const year = parts[2].toString().substr(-2);

    // Convert the month abbreviation to its Arabic name
    const monthIndex = new Date(dateString + ' 0:00:00').getMonth();
    const monthNameArabic = monthNamesArabic[monthIndex];

    // Return the date in the desired format
    return `${day}-${monthNameArabic}-${year}`;
  }

  reschaduleTest() {
    debugger;
    console.log(
      this.chsApmntDate.split,
      '===',
      formatDate(this.chsApmntDate, 'YYY-MM-dd', 'en-us')
    );

    if (this.reShdulBtnValue == 'Reschedule') {
      this.presentLoading();
      let total_amount = this.TotalCost;
      let roundedTotalAmount = Number(total_amount.toFixed(3));
      let apiData = JSON.stringify({
        oldBookingId: this.particularReschData.labbookingId,
        patientId: this.particularReschData.patient_id,
        lab_vendor_id: this.particularReschData.labId,
        test_date: formatDate(this.chsApmntDate, 'YYY-MM-dd', 'en-us'),
        test_time: this.chsApmntTime,
        total_amount: roundedTotalAmount,
        paymentStatus: '1',
        isMember: this.particularReschData.is_member,
        tempMemberName: this.particularReschData.patientName,
        test: this.storeSelectedLapTestConverted,
        refbook_Id: this.bookref_id,
      });
      this.services
        .postRequest('patientLabBookingReschedule', apiData)
        .subscribe((res) => {
          if (res.status == 1) {
            setTimeout(() => {
              this.loadingController.dismiss();
            }, 1000);
            this.AlertInfo(this.addCall.title446, res.status);
            this.ChangeEvent.emit('isLabBack');
            this.isShowHeaderValue = false;
            this.pageNo = 1;
            this.bookingListData = [];
            this.bookingList();
          } else {
            setTimeout(() => {
              this.loadingController.dismiss();
            }, 1000);
            this.AlertInfo(res.msg, res.status);
          }
        });
    } else if (this.reShdulBtnValue == 'Repeat') {
      this.storeSelectedLapTest = [];
      this.chsApmntTime = this.chsApmntTime.split('+')[0];
      for (let item of this.particularReschData.LabBookedTestData) {
        this.storeSelectedLapTest.push({
          testId: item.testDetailsId,
          testName: item.lab_test_name,
          test_amount: item.test_amount,
        });
      }
      this.AddBooking('repeatBooking');
    }
  }

  //--------\/------BACK FLOW ONLY------\/---------//

  goBack(value) {
    debugger;
    this.pageNo = 1;
    if (value == 'goLabList') {
      this.getAdd();
      this.bookingPage = false;
      this.showcoment = false;
      this.showProgressBar = true;
      this.getLabList = [];
      this.searhFilter = '';
      this.pageNo = 1;
      this.showLabListPage(8);
      this.presentView = 'labListPage';
      this.backValue = 'goHome';
      this.canceldBookingIcon = false;
      this.headerValue = '';
      this.backtobooklist = false;
      this.showoffertest = false;
    } else if (value == 'goLabInfo') {
      this.backtobooklist = false;
      this.isShow = true;
      this.presentView = 'selectedLabPage';
      this.labProfile = true;
      this.bookingPage = false;
      this.bookingConformPage = false;

      if (this.reShdulBtnValue == 'labprofile') {
        this.selectLab(this.storeLabId, 'labprofile', '');
        this.backValue = 'goLabList';
      } else if (this.reShdulBtnValue == 'Reschedule') {
        this.bookingPage = false;
        this.backValue = 'goBookingList';
        this.backtobooklist = false;
        this.showcoment = false;
      } else if (this.reShdulBtnValue == 'Repeat') {
        this.showcoment = false;
        this.bookingPage = false;
        this.backValue = 'goCancelBookingList';
      } else if (this.showoffertest == true) {
        this.backValue = 'goLabList';
        this.showoffertest = false;
      }
      this.headerValue = this.addCall.title745;
    } else if (value == 'goBooking') {
      this.showcoment = false;
      this.bookingPage = true;
      this.labProfile = false;
      this.bookingConformPage = false;
      if (this.reShdulBtnValue == 'referralpage') {
        this.headerValue = this.addCall.title370;
        this.backValue = 'Referral';
      } else if (this.reShdulBtnValue == 'labprofile') {
        this.headerValue = this.storeLabName;
        this.backValue = 'goLabInfo';
      } else if (this.reShdulBtnValue == 'Repeat') {
        this.headerValue = this.addCall.title94;
        this.backValue = 'goCancelBookingList';
      } else if (this.reShdulBtnValue == 'Reschedule') {
        this.headerValue = this.addCall.title50;
        this.backValue = 'goBookingList';
      } else if (this.reShdulBtnValue == 'deal') {
        this.headerValue = this.addCall.title603;
        this.backValue = 'goLabList';
      }
    } else if (value == 'goConfirmBooking') {
      this.AddBooking(this.storeFlowValue);
    } else if (value == 'goBookingList') {
      this.bookingPage = false;
      this.bookingListData = [];
      this.pageNo = 1;
      this.wayOfBookingListpages('bookingList');
      this.ChangeEvent.emit('isLabBack');
      this.isShowHeaderValue = false;
    } else if (value == 'goCancelBookingList') {
      this.bookingPage = false;
      this.bookingHistoryList = [];
      this.pageNo = 1;
      this.wayOfBookingListpages('bookingHisList');
      this.ChangeEvent.emit('isLabBack');
      this.isShowHeaderValue = false;
    } else if (value == 'goHome') {
      this.router.navigate(['/tabs/home']);
      this.searchValue1 = '';
      this.searhFilter = '';
    } else if (value == 'goReBookingPage') {
      this.showRescadulePage('Repeat', this.storeHisListIndex, '','');
    } else if (value == 'Referral') {
      if(this.presentInfoViewBack =="referralinfopage"){
        this.openreferral();
        this.isShowHeaderValue = false;
      }
      else if (this.headerValue == this.addCall.title370) {
        this.viewReferral(this.viewReferralIndex,"");
      } else if (this.headerValue == this.addCall.title372) {
        this.openreferral();
        this.isShowHeaderValue = false;
      }
    } else if (value == 'goNotification') {
      this.router.navigate(['/tabs/commonNotification',{module: 'Lab',modulepic: 'assets/img/notification-lab.png',moduleid: '2'}]);
    } else {
      this.showLabListPage(9);
      this.searhFilter = '';
    }
    this.isMuteVideo = false;
    this.isConfirmed = false;
  }

  resetVariable() {
    this.oldbookingid = 0;
    this.isDateSel = false;
    this.test = 'id';
    this.getLabList = [];
    this.particularLab = null;
    this.storeLabId = null;
    this.labTestPakage = [];
    this.testId = null;
    this.labSubTestList = [];
    this.storeSelectedLapTest = [];
    this.storeSelectedLapTestConverted = [];
    this.TotalCost = 0;
    this.patientDetails = null;
    this.chsApmntDate = null;
    this.chsApmntTime = null;
    this.bookingListData = [];
    this.EmtyDataList = null;
    this.EmtyData = null;
    this.particularBkgData = null;
    this.bookingHistoryList = [];
    this.particularHisData = null;
    this.storeBookingId = null;
    this.currentTime = null;
    this.currentDate = null;
    this.storeHisListIndex = null;
    this.particularReschData = null;
    this.searhFilter = '';
    this.storeLabName = null;
    this.search = false;
    this.offerSoring = true;
    this.rateSoring = false;
    this.offrSortOrder = 'DESC';
    this.rateSortOrder = 'DESC';
    this.storePatientName = null;
    this.getDate = null;
    this.getTime = null;
    this.StoreWayBookingPageFlow = null;
    this.pageNo = 1;
    this.noData = 0;
    this.skeletonLoad = [];
    this.noMedia = null;
    this.showVideoOptins = null;
    this.selectedDate = null;
    this.Date = null;
    this.reletionList = null;
    this.bookingAmnt = null;
    this.nextCount = null;
    this.setTime = null;
    this.storeWorkingHours = [];
  }

  async openPopovr(event: any) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: event,
      translucent: true,
      componentProps: {
        from: 'Lab',
        labDet: this.testslt,
        fromdate: this.Date,
      },
      cssClass: 'offrMod',
    });
    return await popover.present();
  }

  async openPopovr1(event: any) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: event,
      translucent: true,
      componentProps: {
        from: 'Lab1',
        labDet: this.showtestamt,
      },
      cssClass: 'offrMod',
    });
    return await popover.present();
  }

  async reviewPopup(labId, proImg, labName, reviewcount, labbookingid) {
    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: labId,
          Img: proImg,
          Name: labName,
          From: 'Lab',
          bookingId: labbookingid,
        },
      });
      alert.onDidDismiss().then((data) => {
        if (data.data == 'dismiss') {
          this.wayOfBookingListpages('bookingHisList');
        }
      });
      await alert.present();
    }
  }

  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    debugger
    if (this.storedPath === path) {
      this.showPopover(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover(type, path, thumbnail);
    }
  }

  private async showPopover(type: any, path: any, thumbnail: any) {
    debugger
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }

  showHideRev() {
    if (this.reviewCmt.length != 1) {
        if (this.showcoment == true) {
             this.showcoment = false;
        } else {
             this.showcoment = true;
        }
    }else{
      if (this.showcoment == false) {
        this.showcoment = true;
      } else {
        this.showcoment = false;
      }
    }
  }

  slideChanged() {
    let _obj = this;
    this.slides.getActiveIndex().then((res) => {
      _obj.idx = res;
      let setId;
      let i = 0;
      for (let item of this.particularLab.LabmediaDetails) {
        if (item.media_type === 'video' || item.media_type === 'Video') {
          if (_obj.idx === i) {
            setId = i + this.test1 + item.mediaId;
            this.vdo = document.getElementById(setId);
            _obj.vdo.play();
            item.playMode = true;
          } else {
            setId = i + this.test1 + item.mediaId;
            _obj.vdo = document.getElementById(setId);
            _obj.vdo.pause();
            item.playMode = false;
          }
        }
        i++;
      }
    });
  }

  itemHeightFn(item, index) {
    return 520;
  }

  userTrackBy(index, user) {
    return user.doctorId;
  }

  scrollMethod(event) {
    let elmnt = document.getElementById('scrolldiv');
    if (this.getLabList.length > 0 && this.getLabList.length >= this.cardNum) {
      let myElement = document.getElementById('listdiv_' + this.cardNum);
      if (document.getElementById('listdiv_' + this.cardNum)) {
        let bounding = myElement.getBoundingClientRect();
        let position = bounding.top + window.scrollY;
        if (
          ((bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.right <= window.innerWidth &&
            bounding.bottom <= window.innerHeight) ||
            elmnt.scrollTop > position) &&
          this.nextCount.includes(0) != true &&
          this.hitApi.includes(this.cardNum) != true
        ) {
          this.loadData('');
          this.hitApi.push(this.cardNum);
          this.cardNum += 10;
        }
      }
    } else {
      console.log('scroll to top');
    }
  }

  ReferralList: any = [];
  viewRefDetails: any = [];
  refstat: any;

  openreferral() {
    this.changepage();
    this.refstat = null;
    this.p_Name = localStorage.getItem('patientName');
    this.presentView = 'Referral';
    this.backValue = 'goBookingList';
    this.headerValue = this.addCall.title371;
    this.canceldBookingIcon = false;
    this.viewBookingList = false;
    this.viewCanceledBookingList = false;
    this.viewCancelBookingInfo = false;

    let apiDate = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
    });

    this.services
      .postRequest('Referrallabpagelist', apiDate)
      .subscribe((res) => {
        this.refstat = res.status;
        this.ReferralList = res.data.details;
      });
  }

  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    const top = Math.round(rect.top);
    const left = Math.round(rect.left);
    const bottom = Math.round(rect.bottom);
    const right = Math.round(rect.right);
    return (
      top >= 0 &&
      left >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  pausePlay(id, mid) {
    const uniqueVideoId = `VideoLab${id}${mid}`;
    if (this.currentPlaying?.id !== uniqueVideoId) {
      if (this.currentPlaying) this.currentPlaying.pause();
      this.currentPlaying = document.getElementById(uniqueVideoId);
    }
    if (this.currentPlaying) {
      this.currentPlaying.paused
        ? this.currentPlaying.play()
        : this.currentPlaying.pause();
    }
  }


  didScrollEvent(event) {
    debugger;
    try {
      if (this.Addcheckvarible) return;
      const inViewPort = this.vdoPlayer.find((player) =>
        this.isElementInViewPort(player.nativeElement)
      );
      if (inViewPort && this.currentPlaying !== inViewPort.nativeElement) {
        if (this.currentPlaying) this.currentPlaying.pause();
        this.currentPlaying = inViewPort.nativeElement;
        this.currentPlaying.paused
          ? this.currentPlaying.play()
          : this.currentPlaying.pause();
      } else if (!inViewPort && this.currentPlaying) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
      }
    } catch (err) {
      console.error(err);
    }
  }

  frmreferral_page: boolean = false;
  bookref_id: any;

  referrealtestid: any = [];
  viewReferral(i,value) {
    this.isShowHeaderValue = true;
    this.ChangeEvent.emit('profile');
    this.commonheadervalue = 'Lab';
    this.docpro = '';
    this.viewRefDetails = this.ReferralList[i];

    let tsid = this.viewRefDetails.testID.split(',');
    this.bookref_id = this.viewRefDetails.refId;
    this.referrealtestid = [];
    tsid.forEach((i) => {
      this.referrealtestid.push({lab_test_id: i});
    });
    this.reftest = this.viewRefDetails?.test?.split(',');
    this.storeLabName = this.viewRefDetails.LabName;
    this.storeLabId = this.viewRefDetails.lab_id;
    this.LabAddress = this.viewRefDetails.vendor_address;
    this.storeMemberPatient = this.viewRefDetails.PatientName;
    this.storeMemberPatientId = this.viewRefDetails.patientMemberId;
    this.presentView = 'viewReferral';
    this.viewReferralIndex = i;
    this.backValue = 'Referral';
    this.headerValue = this.addCall.title372;
    this.presentInfoViewBack = "";
    if(value == "referralinfo"){
    this.presentInfoViewBack = "referralinfopage";
    this.selectLab(this.storeLabId, "referralpage", '');
    }
  }

  Docpro(Docid, clinicid, splname, splid, Docname) {
    localStorage.setItem('fromPage', 'labreferral');
    this.router.navigate(['/tabs/doc-appointment',
      {
        doctorId: Docid,
        clinicId: clinicid,
        searchDate: new Date().toISOString().split('T')[0],
        serviceTypeId: '',
        splid: splid,
        Gender: '',
        splname: splname,
        docname: Docname,
        frm: 'referral',
      },
    ]);
  }

  showoffertest: boolean = false;
  dealdetaild: any = [];
  async offrDtils(myEvent, dealDet, details, i) {
    this.dealdetaild = [];
    this.showoffertest = false;
    this.storeLabId = details.labId;
    this.reShdulBtnValue = 'labprofile';

    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: 'lab',
        dealdetails: dealDet,
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data) {
        this.dealslistRef = data.data.datafortrainer;
        this.Date = new Date();
        let monthNames = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        let day = ('0' + this.Date.getDate()).slice(-2);
        let month = monthNames[this.Date.getMonth()];
        let year = this.Date.getFullYear().toString().slice(-2);

        this.getDate = day + '-' + month + '-' + year;
        console.log('getDate-->', this.getDate);
        if (this.addCall.selectedLanguage == 'ea') {
          this.getDate = this.convertArabFormat(this.getDate);
        }
        console.log('check', this.getDate);
        this.chsApmntDate = this.Date.getFullYear() + '-' + ('0' + (this.Date.getMonth() + 1)).slice(-2) + '-' + ('0' + this.Date.getDate()).slice(-2);
        this.dealdetaild.push({ lab_test_id: data.data.datafortrainer.testid });
        this.showoffertest = true;
        this.selectLab(this.storeLabId, 'deal', '');
      }
    });
    return await popover.present();
  }

  lastTapTime: number = 0;
  delay: number = 300;
  doubleClick(count, index, labId, isLiked) {
    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(index, labId, 1, 2, isLiked == 1 ? "true" : "false");
      this.counts += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;
  }

  makeLikes(i, docId, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: docId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Lab',
        isLiked: isLiked
      });
      const UpdateVendorLikes = this.services
        .postRequestDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            console.log(res);
            if (this.getLabList[i].isLiked != 1) {
              this.getLabList[i].likes_count =
                Number(this.getLabList[i].likes_count) + 1;
            }
            this.getLabList[i].isLiked = 1;
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  makeLike(index, labid, like, frm, isLiked) {
    try {
      if (frm == 1) {
        if (this.getLabList[index].isLiked == 0) {
          this.getLabList[index].isLiked = 1;
          this.getLabList[index].likes_count =
            Number(this.getLabList[index].likes_count) + 1;
        } else if (this.getLabList[index].isLiked == 1) {
          this.getLabList[index].isLiked = 0;
          this.getLabList[index].likes_count =
            Number(this.getLabList[index].likes_count) - 1;
        }
        if (this.getLabList[index].isLiked == null) {
          this.getLabList[index].isLiked = 1;
          this.getLabList[index].likes_count =
            Number(this.getLabList[index].likes_count) + 1;
        }
      } else if (frm == 2) {
        if (this.particularLab.isLiked == 0) {
          this.particularLab.isLiked = 1;
          this.particularLab.likes_count =
            Number(this.particularLab.likes_count) + 1;
        } else if (this.particularLab.isLiked == 1) {
          this.particularLab.isLiked = 0;
          this.particularLab.likes_count =
            Number(this.particularLab.likes_count) - 1;
        }
        if (this.particularLab.isLiked == null) {
          this.particularLab.isLiked = 1;
          this.particularLab.likes_count =
            Number(this.particularLab.likes_count) + 1;
        }
      }

      let data = JSON.stringify({
        vendor_id: labid,
        like: like,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Lab',
        isLiked: (isLiked == 1) ? "true" : "false"
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  nextcount1: any;

  loadrevcomments() {
    let requestdata = JSON.stringify({
      limit: 10,
      pageno: this.pagenorev,
      vendorid: this.particularLab.labId,
      patientid: localStorage.getItem('patient_id'),
      vendortypeid: 2,
    });

    this.services
      .postRequest('getVendor_review', requestdata)
      .subscribe(async (res) => {
        debugger;
        if (res.data.length != 0 ) {
          this.nextcount1 = res.data[res.data.length - 1]?.NextCount;
          for (let item = 0;item < res.data.length;item++) {
            this.revArr.push(res.data[item]);
          }
          if (this.scrollEvent) {
            this.scrollEvent.target.complete();
          }
        }
      });
  }

  onIonInfinite(ev) {
    this.scrollEvent = ev;
    if (this.nextcount1 == 0) {
      ev.target.disabled = true;
    } else {
      this.pagenorev += 1;
      this.loadrevcomments();
    }
  }

  showtestdetails: boolean = false;

  showtestdet(index, item) {
    debugger;
    if (this.labTestPakage[index].testdetarrow == false) {
      this.labTestPakage[index].testdetarrow = true;
      this.showtestdetails = true;
      this.testId = this.labTestPakage[index].labTestCategoryId;

      if (this.labTestPakage[index].labSubTestList == null) {
        if (this.reShdulBtnValue != 'Reschedule') {
           console.log(this.reShdulBtnValue,"reShdulBtnValue");
        }
      }
    } else if (this.labTestPakage[index].testdetarrow == true) {
      this.labTestPakage[index].testdetarrow = false;
    }
  }

  testslt: any = [];
  showproceedbook: boolean = false;
  tstmngID: any = [];
  testIdlist: any = [];

  testcount(test: any, index, i) {
    if (this.labTestPakage[index].labSubTestList[i].nonselect == false) {
      if (!this.testIdlist.includes(test.testId)) {
        this.testIdlist.push(test.testId);
        this.testslt.push(test);
        setTimeout(() => {
          this.labTestPakage[index].labSubTestList[i].selected = true;
        }, 100);
        if (!this.tstmngID.includes(test.testId)) {
          this.tstmngID.push(test.testId);
        }
      } else {
        setTimeout(() => {
          this.labTestPakage[index].labSubTestList[i].selected = false;
        }, 100);

        let indes = this.testslt
          .map((item) => item.testId)
          .indexOf(test.testId);
        this.testIdlist.splice(indes, 1);
        this.testslt.splice(indes, 1);

        if (this.tstmngID.includes(test.testId)) {
          let testind = this.tstmngID.indexOf(test.testId);
          this.tstmngID.splice(testind, 1);
        }
      }
      if (this.testslt.length > 0) {
        this.showproceedbook = true;
      }
    } else {
      setTimeout(() => {
        this.labTestPakage[index].labSubTestList[i].selected = true;
      }, 150);
    }
  }

  async viewMore(frm: any, cname: any) {
    let data = null;
    if (frm == 'test') {
      data = this.showslt_test;
    } else if (frm == 'test1') {
      data = this.showtestname;
    }

    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      backdropDismiss: false,
      componentProps: {
        From: frm,
        selected_test: data,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  async view_WorkHoures() {
    let popup = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'work_Hours',
      backdropDismiss: false,
      componentProps: {
        From: 'lab_work',
        workinghours: this.workinghrs,
      },
    });

    return await popup.present();
  }

  show_testbut: boolean = false;

  Viewprofile() {
    this.show_testbut = true;
    this.headerValue = this.particularLab.Lab;
    this.bookingPage = false;
    this.labProfile = true;
    this.bookingConformPage = false;
    this.backValue = 'goBooking';
  }

  opentime() {
    $('#time').click();
  }

  changepage() {
    this.ChangeEvent.emit('refferal');
  }
  Videobruff(el) {
    return true;
  }

  ionViewDidLeave() {
    const inViewPort = this.vdoPlayer.find((player) =>
      this.Videobruff(player.nativeElement)
    );
    if (inViewPort) {
      inViewPort.nativeElement.pause();
    }
    this.didScrollEvent('leave');
    this.isMuteVideo = false;
    this.common.videoSound = false;
    if (this.currentPlaying) {
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }
    setTimeout(() => {
      this.didScrollEvent('leave');
      this.isMuteVideo = false;
      this.common.videoSound = false;
      if (this.currentPlaying) {
        this.currentPlaying.muted = true;
        this.currentPlaying?.pause();
        this.currentPlaying = null;
      }
    }, 500);
    this.getLabList = [];
  }


  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT = min.toISOString().split('T')[0] + 'T' + min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 2,
        current_date: today,
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.Addcheckvarible = true;
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            } else {
              this.Addcheckvarible = false;
              setTimeout(() => {
                this.didScrollEvent(event);
              }, 1000);
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss().then((data) => {
      this.Addcheckvarible = false;
      if (!this.Addcheckvarible) {
        this.didScrollEvent(event);
      }
    });
    return await popover.present();
  }

  async presentModal1() {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: 'pay',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      this.gopayment = true;
      this.payType = data.data;
      const loading = await this.loadingController.create({
        message: 'Please wait we are redirecting you to the payment gateway',
      });
      if (data.data == '1') {
        await loading.present();

        this.payment
          .getsessionid(
            this.storePatientName,
            this.Email,
            this.Phoneno,
            this.TotalCost
          )
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(res, "MASTER");
          });
      } else if (data.data == '2') {
        await loading.present();
        this.payment
          .getKnetsessionid('', this.Email, this.Phoneno, this.TotalCost)
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(res, "KNET");
          });
      }
      // else if (data.data == '3') {
      //   await loading.present();
      //   this.payment
      //     .getApplesessionid(this.storePatientName, this.Email, this.Phoneno, this.TotalCost)
      //     .then(async (res: any) => {
      //       await loading.dismiss();
      //       this.gatewayFunction(res, "APPLE PAY");
      //     });
      // }

      this.payType = '';
      this.gopayment = false;
    });
    return await modal.present();
  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      },
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg == this.addCall.title620) {
        this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }
  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    return await modal.present();
  }
  async view_address(data:any) {
    let popup = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'work_Hours',
      backdropDismiss: false,
      componentProps: {
        From: 'address',
        showadress: data,
      },
    });

    return await popup.present();
  }



  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Lab');

    this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }

            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);

            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }

            const documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on =  new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {

                const modified_on =  new Date();

                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                const localBlob = new Blob([blob], { type: 'application/pdf' });
                const fileName = `report_${new Date().getTime()}.pdf`;
                await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                  .then((fileEntry) => {
                    console.log("File entry:", fileEntry);
                    this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                      .then(() => console.log('File is opened'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(e => console.log('Error writing file', e));
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });

          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }



}
